var downloadUrl = '/judgeagent/common/version';
export default downloadUrl;